module.exports = __webpack_public_path__ + "static/assets/11b66c5446289baa859ec6275b58b5b5.png";